import type { ReactElement, ReactNode } from 'react';
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from '@/ui/design-system/components/ui/tooltip';

/**
 * Design-system tooltip with the inline-visuals defaults (per-instance provider
 * like LifeCycleBadge, capped width for sentence-length detail). The child is
 * the hover/focus trigger; renders the bare child when there is no content.
 */
const VisualTooltip = ({
    content,
    children,
}: {
    content?: ReactNode;
    children: ReactElement;
}) =>
    content ? (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>{children}</TooltipTrigger>
                <TooltipContent className="max-w-64">{content}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    ) : (
        children
    );

export default VisualTooltip;
